// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SliderDots_wrapper__jGV_R","clientsWrapper":"SliderDots_clientsWrapper__FIHKd","client":"SliderDots_client__izndN","activeClient":"SliderDots_activeClient__sJDjy"};